import { render, staticRenderFns } from "./NuevaTareaGeneral.vue?vue&type=template&id=13424b76&"
import script from "./NuevaTareaGeneral.vue?vue&type=script&lang=js&"
export * from "./NuevaTareaGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports